'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      enableColorScheme
      // Bootstrap runs in server HTML. Client mounts use the provider's effects;
      // keep that copy inert to avoid React 19's executable-script warning.
      scriptProps={{
        type: typeof window === 'undefined' ? 'text/javascript' : 'text/plain',
      }}
    >
      {children}
    </NextThemesProvider>
  );
}
